import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { WidgetBody } from '../../../components/Authentication/components/WidgetBody.js';
import { resetErrors as resetApiErrors } from '../../../components/Authentication/redux/actions.js';
import { useAuthentication } from '../../../hooks/index.js';
import { ContentLayer } from '../../../primitives/index.js';
import { AUTHENTICATION_QA_ID, qaId } from '../../../utils/qaId.js';
export const WidgetLayout = /*#__PURE__*/_styled(({
  children,
  widget,
  onCloseClick,
  title,
  ...restProps
}) => {
  const {
    toggleWidget,
    isComponentOpen
  } = useAuthentication();
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation('authentication');
  const handleCloseDialog = () => {
    dispatch(resetApiErrors());
    onCloseClick?.();
    toggleWidget(widget);
  };
  return _jsx(ContentLayer, {
    title: title,
    visuallyHideTitle: true,
    closeButtonLabel: t('closeDialog'),
    "data-testid": qaId(AUTHENTICATION_QA_ID, `${widget}-widget`),
    open: isComponentOpen('widget', widget),
    onClose: handleCloseDialog,
    small: true,
    ...restProps,
    children: _jsx(WidgetBody, {
      children: children
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e14dwvr70"
} : {
  target: "e14dwvr70",
  label: "WidgetLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "1f3elew",
  styles: "width:100%;max-width:400px"
} : {
  name: "1f3elew",
  styles: "width:100%;max-width:400px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});